module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/empty-layout.component.html
// module id = 869
// module chunks = 29